// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"OffersList_nameCell__2WB2_","button":"OffersList_button__2oOmk"};